import { Col, Container, Row } from "react-bootstrap";
import { SideNav } from "../shared-components/side-nav";
import { Accordion, Card, Tabs, TextBox } from "@veneer/core";
import React, { useEffect, useState } from "react";
import { apiPost } from "../../../services/service";
import { POST_PRODUCT_INFO, POST_PRODUCT_LOAD } from "../../../services";
import { DetailsWarranty } from "./details-warranty";
import { DetailsContact } from "./details-contract";
import { DetailsExtended } from "./details-extended";
import { useSearchParams } from "react-router-dom";
import CaseItems from "@components/home-page/shared-components/case-items/case-items";
import "./product-details.scss";
import { useTranslation } from "react-i18next";

export const ProductDetail = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [pageLoad, setPageLoad] = React.useState<any>([]);
  const [getProductInfo, setProductInfo] = React.useState<any>([]);
  const [getPolyProductInfo, setPolyProductInfo] = React.useState<any>([]);
  const [ISResponse, setISResponse] = React.useState<any[]>([]);
  const [ContractEntitlement, setContractEntitlement] = React.useState<any[]>(
    []
  );
  const [searchParams] = useSearchParams();
  const {t} = useTranslation();

  const changeTabHandler = (id: any) => {
    setActiveTab(id);
  };
  useEffect(() => {
    async function fetchMyAPI() {
      try {
        const payloadpageload = {
          contactid: "85680c15-7814-e711-80fc-5065f38ad971",
          ainfo: searchParams.get("ainfo"),
          pno: searchParams.get("pno"),
          tabid: "1",
          
          
        };

        const pageloadres: any = await apiPost(
          POST_PRODUCT_LOAD,
          payloadpageload
        );
        if (pageloadres.data) {
          let pgload = pageloadres.data;
          setPageLoad(pageloadres.data);
          let isres = JSON.parse(pgload?.ISResponse);
          setISResponse(isres);
          setContractEntitlement(isres[0]["Assets"][0]["ContractEntitlement"]);
        }

        const payload = {
          ainfo: searchParams.get("ainfo"),
          pinfo: "",
          pno: searchParams.get("pno"),
          contactid: "85680C15-7814-E711-80FC-5065F38AD971",
          
          
        };
        const productInfo: any = await apiPost(POST_PRODUCT_INFO, payload);
        if (productInfo.data) {
          let pdtData = productInfo.data;
          setProductInfo(pdtData);
        }
        setPolyProductInfo(payload);
      } catch (error) {
        console.error("Error fetching recent cases:", error);
      }
    }
    fetchMyAPI();
  }, []);

  return (
    <>
      <Container fluid>
        <div className="product-details">
          <div className="header">
            <h2>{t('HPI.Product.productdetails.ProductDetails',{defaultValue:'Product Details'})}</h2>
          </div>
          <Container className="card-container">
            <CaseItems
              data={getProductInfo}
              polyData={getPolyProductInfo}
              selectedcasepriority={pageLoad?.selectedcasepriority}
              ContractEntitlementStatus={ContractEntitlement}
            ></CaseItems>
          </Container>
          <Container className="p-5 pt-3 inner-container">
            <Row>
              <Col className="detail-container">
                {/* <h5>Details</h5> */}
                <Tabs
                  controlId="default"
                  mode="contained"
                  onChangeTab={changeTabHandler}
                  selectedTabId={activeTab}
                  className="mt-3"
                  tabs={[
                    {
                      id: 0,
                      label: t('HPI.Product.productdetails.ContractDetails',{defaultValue:'Contract Details'}),
                      content: (
                        <div
                          className="label"
                          style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                            padding: "30px",
                            marginBottom: "15px",
                          }}
                        >
                          <DetailsContact
                            data={ContractEntitlement}
                            flag="contract"
                            type="Contract"
                          />
                        </div>
                      ),
                    },
                    {
                      id: 1,
                      label: t('HPI.Product.Warranty.WarrantyDetails',{defaultValue:'Warranty Details'}),
                      content: (
                        <div
                          className="label"
                          style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                            padding: "30px",
                          }}
                        >
                          <DetailsWarranty
                            data={ContractEntitlement}
                            flag="warranty"
                            type="Base warranty"
                          />
                        </div>
                      ),
                    },
                    {
                      id: 2,
                      label: t('HPI.Product.ExtendedWarranty.ExtendedWarranty',{defaultValue:'Extended Warranty'}),
                      content: (
                        <div
                          className="label"
                          style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                            padding: "30px",
                          }}
                        >
                          <DetailsExtended
                            data={ContractEntitlement}
                            flag="carepack"
                            type="HP extended warranty"
                          />
                        </div>
                      ),
                    },
                  ]}
                  type="attached"
                />
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
    </>
  );
};
